module.exports = __webpack_public_path__ + "static/media/Oracle.ca375ad8.png";